"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLazyEntry = void 0;
var RegistryError_1 = require("../../errors/RegistryError");
var createComponentLoader_1 = require("../../componentLoader/createComponentLoader");
var loadBundle_1 = require("../../componentLoader/loadBundle");
var loadAssets_1 = require("../../componentLoader/loadAssets");
var createComponentsLoaders_1 = require("./createComponentsLoaders");
function loadBatchComponents(_a) {
    var _this = this;
    var transport = _a.transport, batches = _a.batches, manifest = _a.manifest, shouldLoadCSSAssets = _a.shouldLoadCSSAssets, runtime = _a.runtime;
    var tasks = Object.keys(manifest.batches)
        .filter(function (batchName) { return batches.includes(batchName); })
        .map(function (batchName) { return __awaiter(_this, void 0, void 0, function () {
        var batch, batchComponents;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    batch = manifest.batches[batchName];
                    return [4 /*yield*/, loadBundle_1.loadBundleComponents(transport, batch.id, batch.url, runtime)];
                case 1:
                    batchComponents = _a.sent();
                    if (shouldLoadCSSAssets) {
                        loadAssets_1.loadBatchAssets(manifest.assets, batchName);
                    }
                    return [2 /*return*/, createComponentsLoaders_1.createComponentsLoaders(batchComponents, manifest, batchName)];
            }
        });
    }); });
    return Promise.all(tasks);
}
// ---
function createLazyEntry(_a) {
    var _this = this;
    var manifests = _a.manifests, transport = _a.transport;
    return function (params) {
        var tasks = manifests.map(function (_a) {
            var manifest = _a.manifest, library = _a.library;
            return __awaiter(_this, void 0, void 0, function () {
                var components_1, batchComponents, _b, registerComponent_1, registerLibrary;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!manifest.components) return [3 /*break*/, 4];
                            components_1 = {};
                            if (!(params.batches && params.batches.length)) return [3 /*break*/, 2];
                            return [4 /*yield*/, loadBatchComponents({
                                    transport: transport,
                                    batches: params.batches,
                                    manifest: manifest,
                                    shouldLoadCSSAssets: params.shouldLoadCSSAssets,
                                    runtime: library.runtime,
                                })];
                        case 1:
                            _b = _c.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _b = [];
                            _c.label = 3;
                        case 3:
                            batchComponents = _b;
                            batchComponents.forEach(function (batch) {
                                Object.keys(batch).forEach(function (componentName) {
                                    if (components_1[componentName]) {
                                        throw RegistryError_1.createException('Duplicated component at the batch bundles', RegistryError_1.RegistryErrorCode.IncorrectBatches).withComponent(componentName);
                                    }
                                    components_1[componentName] = batch[componentName];
                                });
                            });
                            Object.keys(manifest.components).forEach(function (componentName) {
                                /**
                                 * should not set loader, if component was loaded with batch request
                                 */
                                if (!components_1[componentName]) {
                                    var component = manifest.components[componentName];
                                    components_1[componentName] = createComponentLoader_1.createComponentLoader({
                                        transport: transport,
                                        component: component,
                                        shouldLoadCSSAssets: params.shouldLoadCSSAssets,
                                        runtime: library.runtime,
                                    });
                                }
                            });
                            registerComponent_1 = params.registerComponent, registerLibrary = params.registerLibrary;
                            if (registerComponent_1) {
                                Object.keys(components_1).forEach(function (componentName) {
                                    var loader = components_1[componentName];
                                    registerComponent_1(componentName, loader);
                                });
                            }
                            if (registerLibrary) {
                                registerLibrary(library.artifactId, components_1, manifest.assets);
                            }
                            _c.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            });
        });
        return Promise.all(tasks);
    };
}
exports.createLazyEntry = createLazyEntry;
//# sourceMappingURL=createLazyEntry.js.map